<template lang="pug">
modal#follow-up-envelope-modal(
  :no-footer='isPublic && !isBradescoVersion'
  :process-button-label='$t("button.ok")'
  :show-cancel-button='false'
  :title='$t("modal.followUpEnvelope.title")'
  @process='$emit("confirm")'
  ref='modal'
  size='sm'
)
  p.justify-center {{ $t('modal.followUpEnvelope.message') }}
  .text-center.mt-4
    img.img-fluid(src='/img/ilustrations/followup-document.svg')
  div(v-if='isPublic && !isBradescoVersion')
    buttons-login-and-create-account.mt-4
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import ButtonsLoginAndCreateAccount from '@/modules/business/components/molecules/ButtonsLoginAndCreateAccount.vue';
import ApplicationService from '@/services/ApplicationService';

export default {
  name: 'FollowUpEnvelopeModal',
  components: {
    Modal,
    ButtonsLoginAndCreateAccount,
  },
  props: {
    isPublic: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    closeButtonLabel() {
      return this.isPublic && !this.isBradescoVersion
        ? ''
        : this.$t('button.ok');
    },
    isBradescoVersion() {
      return ApplicationService.isSelfRegistrationBlock();
    },
  },
};
</script>
